import type {
  ModelMetadata,
  ModelRequest,
  ModelSettingsReasoningEffort,
} from '../../model';
import {
  type AnthropicCompatibleClient,
  type AnthropicCompatibleFetch,
  AnthropicCompatibleMessagesModel,
} from '../anthropic-compatible/messages-model';
import { DEEPSEEK_ANTHROPIC_RAW_MODEL_EVENT_SOURCE } from './raw-model-events';

export type DeepSeekAnthropicFetch = AnthropicCompatibleFetch;
export type DeepSeekAnthropicClient = AnthropicCompatibleClient;

const DEEPSEEK_DEFAULT_MAX_TOKENS = 32_768;
const DEEPSEEK_MAX_OUTPUT_TOKENS = 384_000;

export class DeepSeekAnthropicMessagesModel extends AnthropicCompatibleMessagesModel {
  constructor(args: {
    baseURL: string;
    client: DeepSeekAnthropicClient;
    model: string;
    metadata?: ModelMetadata;
  }) {
    super({
      ...args,
      options: {
        providerName: 'DeepSeek',
        rawModelEventSource: DEEPSEEK_ANTHROPIC_RAW_MODEL_EVENT_SOURCE,
        responseIdFallback: 'deepseek-anthropic-response',
        defaultMaxTokens: DEEPSEEK_DEFAULT_MAX_TOKENS,
        maxOutputTokens: DEEPSEEK_MAX_OUTPUT_TOKENS,
        getReasoningSettings: getDeepSeekReasoningSettings,
      },
    });
  }
}

function getDeepSeekReasoningSettings(
  effort: ModelSettingsReasoningEffort | undefined,
  _args: { model: string; request: ModelRequest },
): {
  thinking?: Record<string, unknown>;
  output_config?: Record<string, unknown>;
} {
  if (effort === undefined) {
    return {};
  }
  if (effort === 'none' || effort === null) {
    return { thinking: { type: 'disabled' } };
  }
  return {
    thinking: { type: 'enabled' },
    output_config: { effort: normalizeDeepSeekEffort(effort) },
  };
}

function normalizeDeepSeekEffort(
  effort: Exclude<ModelSettingsReasoningEffort, null>,
): string {
  if (effort === 'xhigh') {
    return 'high';
  }
  if (effort === 'minimal') {
    return 'low';
  }
  return effort;
}
